import { useState } from "react";
import { useEffect } from "react";
import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
// import Image1 from "./img/webp/1Salle de conférence avec plafond lumineux LED architectural – solution acoustique et éclairage intégré UNIK SYSTEM.webp";
// import Image6 from "./img/webp/2Mur acoustique décoratif avec panneaux absorbants et plafond suspendu design pour espace professionnel.webp";
import Image3 from "./img/webp/3Salon moderne avec panneaux muraux acoustiques design et traitement sonore haut de gamme.webp";
import Image4 from "./img/webp/4Séparation d’espace par rideaux acoustiques et éclairage indirect LED dans un intérieur contemporain.webp";
import Image5 from "./img/webp/5Espace de travail élégant avec plafond architectural acoustique et design intérieur premium.webp";
import Image2 from "./img/webp/6Plafond acoustique textile suspendu pour piscine olympique – solution architecturale UNIK SYSTEM.webp";
import Image7 from "./img/webp/7Séparateurs acoustiques textiles design pour bureau moderne – solutions acoustiques UNIK SYSTEM.webp";
import Image8 from "./img/webp/8Traitement acoustique professionnel pour studio audio – panneaux muraux et plafond UNIK SYSTEM.webp";
// import Image9 from "./img/webp/9Salle de conférence design avec éclairage LED intégré et traitement acoustique architectural UNIK SYSTEM.webp";
import Image10 from "./img/webp/10Bureau professionnel avec cloisons acoustiques et panneaux absorbants pour confort sonore.webp";
// import Image11 from "./img/webp/11Salle de spectacle avec plafond acoustique suspendu et panneaux muraux haute performance.webp";
// import Image12 from "./img/webp/12Espace d’accueil moderne avec plafond décoratif acoustique et éclairage architectural.webp";
import Image13 from "./img/webp/13Salon contemporain avec panneaux muraux acoustiques décoratifs et design intérieur premium.webp";
import Image14 from "./img/webp/14Plafond acoustique ondulé en bois avec design architectural haut de gamme UNIK SYSTEM.webp";
import Image15 from "./img/webp/1.webp";
import Image16 from "./img/webp/16Plafond acoustique suspendu en textile vert avec luminaires décoratifs – solution acoustique bureau moderne UNIK SYSTEM (1).webp";
import Image17 from "./img/webp/17Panneaux acoustiques muraux hexagonaux design pour bureau professionnel – traitement acoustique UNIK SYSTEM.webp";
import Image18 from "./img/webp/18Studio d’enregistrement avec panneaux acoustiques muraux et plafonds absorbants – solution acoustique professionnelle UNIK SYSTEM.webp";
import Image19 from "./img/webp/19Plafond acoustique modulaire pour espace collectif et restauration – amélioration du confort sonore UNIK SYSTEM.webp";
import Image20 from "./img/webp/20Plafond technique acoustique pour restaurant et espace public – réduction de la réverbération sonore UNIK SYSTEM.webp";
import Image21 from "./img/webp/2.webp";
import Image22 from "./img/webp/22Salle polyvalente équipée de plafonds acoustiques haute performance – solution UNIK SYSTEM.webp";
import Image23 from "./img/webp/23Complexe sportif avec plafond acoustique textile tendu pour contrôle sonore UNIK SYSTEM.webp";
import Image24 from "./img/webp/24Installation de plafonds acoustiques sur structure métallique dans bâtiment public UNIK SYSTEM.webp";
import Image25 from "./img/webp/25Panneaux muraux acoustiques décoratifs colorés pour espace éducatif UNIK SYSTEM.webp";
import Image26 from "./img/webp/26Installation de plafond tendu acoustique haute performance dans une grande salle publique – solution UNIK SYSTEM.webp";
import Image27 from "./img/webp/27Cabine acoustique design pour bureau open space – isolation phonique et confort acoustique.webp";
import Image28 from "./img/webp/28Plafond acoustique suspendu en textile architectural pour salle de spectacle et théâtre.webp";
import Image29 from "./img/webp/29Panneaux acoustiques muraux design pour restaurant – amélioration du confort sonore et esthétique moderne.webp";
import Image30 from "./img/webp/3.webp";





const images = [
  // { id: 1, src: Image1, title:"Solution acoustique-revêtement acoustique avec intégration LED" },
  { id: 2, src: Image2, title:"Toile acoustique en vélum-piscine olympique de Rabat"},
  { id: 3, src: Image3, title:"Mur en feutrine en découpe  V Cut"},
  { id: 4, src: Image4, title:"Rideau acoustique pli accordéon"},
  { id: 5, src: Image5, title:"Salle de réunion moderne et élégante avec plafond acoustique design"},
  // { id: 6, src: Image6, title:"Espace détente moderne avec panneaux acoustiques muraux et plafond design jaune"},
  { id: 7, src: Image7, title:"Espace de travail élégant avec cloisons acoustiques mobiles et design naturel"},
  { id: 8, src: Image8, title:"Studio d’enregistrement professionnel avec panneaux acoustiques et équipement audio haut de gamme"},
  // { id: 9, src: Image9, title:"Plafond acoustique design moderne"},
  { id: 10, src: Image10, title:"Espace bureau équipé de séparateurs acoustiques" },
  // { id: 11, src: Image11, title:"Salle de spectacle équipée de panneaux acoustiques muraux et plafond"},
  // { id: 12, src: Image12, title:"Espace d’accueil moderne avec plafond acoustique suspendu"},
  { id: 13, src: Image13, title:"Salon contemporain avec bandage en feutrine acoustique et bois en velum"},
  { id: 14, src: Image14, title:"Salle éducative moderne avec plafonds acoustiques suspendus"},
  { id: 15, src: Image15, title:"Tableau acoustique Imprimés"},
  { id: 16, src: Image16, title:"Plafond acoustique suspendu en panneaux ondulés verts"},
  { id: 17, src: Image17, title:"Mur décoratif avec panneaux acoustiques hexagonaux"},
  { id: 18, src: Image18, title:"Studio de production musicale équipé de panneaux acoustiques"},
  { id: 19, src: Image19, title:"Grand espace de restauration avec plafond acoustique modulaire"},
  { id: 20, src: Image20, title:"Grande salle polyvalente avec plafonds acoustiques et éclairage linéaire" },
  { id: 21, src: Image21, title:"Tableau acoustique Imprimés"},
  { id: 22, src: Image22, title:"Installation de plafonds toiles acoustiques"},
  { id: 23, src: Image23, title:"Plafond technique acoustique pour restaurant et espace public – réduction de la réverbération sonore UNIK SYSTEM.jpeg"},
  { id: 24, src: Image24, title:"Installation de panneaux muraux acoustiques décoratifs" },
  { id: 25, src: Image25, title:"Mur décoratif avec panneaux acoustiques colorés"},
  { id: 26, src: Image26, title:"Installation de panneaux muraux acoustiques décoratifs"},
  { id: 27, src: Image27, title:"Cabine acoustique vitrée pour réunions et appels privés"},
  { id: 28, src: Image28, title:"Plafond acoustique suspendu en panneaux textiles ondulés"},
  { id: 29, src: Image29, title:"Restaurant contemporain avec panneaux muraux acoustiques" },
  { id: 30, src: Image30, title:"Tableau acoustique Imprimés"},
];
const Gallery = () => {
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);
  

  return (
    <>
      {/* ===== Title ===== */}
      <div className="container titre-gallry projects-header" id="titre-gallry">
        <h2 data-aos="fade-up" className="section-titles">
          Nos Réalisations – Projets & Installations Professionnelles
        </h2>
        <p data-aos="fade-up">
          Découvrez nos projets réalisés avec expertise et précision.
        </p>
      </div>

      {/* ===== Gallery ===== */}
      <div className="simple-gallery">
        {images.map((img) => (
          <div data-aos="zoom-in" key={img.id} className="gallery-item">
            <img src={img.src} alt={img.title} />

            {/* ✅ Zoom button */}
            <button
              className="zoom-icon"
              onClick={() => setActiveItem(img)}
              aria-label="Zoom image"
              loading="lazy"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </button>
          </div>
        ))}
      </div>

      {/* ===== Lightbox ===== */}
      {activeItem && (
        <div className="lightbox" onClick={() => setActiveItem(null)}>
          <div className="content" onClick={(e) => e.stopPropagation()}>
            <img src={activeItem.src} alt={activeItem.title} loading="lazy"/>
            
            {/* ✅ TITLE */}
            <div className="image-title">
              {activeItem.title}
            </div>

            <button
              className="close"
              onClick={() => setActiveItem(null)}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
